var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgSuccess = function SvgSuccess(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58.6668 13.8133L28.2402 44.2667L16.9335 32.96L20.6935 29.2L28.2402 36.7467L54.9068 10.08L58.6668 13.8133ZM52.7735 27.2533C53.1202 28.7733 53.3335 30.3733 53.3335 32C53.3335 43.7867 43.7868 53.3333 32.0002 53.3333C20.2135 53.3333 10.6668 43.7867 10.6668 32C10.6668 20.2133 20.2135 10.6667 32.0002 10.6667C36.2135 10.6667 40.1068 11.8933 43.4135 14L47.2535 10.16C42.9335 7.11999 37.6802 5.33333 32.0002 5.33333C17.2802 5.33333 5.3335 17.28 5.3335 32C5.3335 46.72 17.2802 58.6667 32.0002 58.6667C46.7202 58.6667 58.6668 46.72 58.6668 32C58.6668 28.8267 58.0802 25.7867 57.0668 22.96L52.7735 27.2533Z",
    fill: "#05A357"
  })));
};

export default SvgSuccess;